import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'

import { appGetAllSanstha } from '../../store/sanstha'
import { appGetAllDashboard } from '../../store/dashboard'
import PostPreview from '../../components/PostPreview/PostPreview'

function Header() {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const [selectedSansthaId, setSelectedSansthaId] = useState(
		localStorage.getItem('sansthaId') || '',
	)

	const user = useMemo(() => {
		try {
			return JSON.parse(localStorage.getItem('user'))
		} catch {
			return null
		}
	}, [])

	const sansthaAdmin = useMemo(() => {
		const data = localStorage.getItem('sansthaAdmin')
		if (!data || data === 'null') return null
		try {
			return JSON.parse(data)
		} catch {
			return null
		}
	}, [])

	const adminName =
		sansthaAdmin?.name ||
		[sansthaAdmin?.firstName, sansthaAdmin?.lastName].filter(Boolean).join(' ')

	const adminSansthas = user?.adminOfSanstha || []
	const permissionSansthas = user?.permissionOfSanstha || []

	let sansthaIds = []

	if (adminSansthas.length > 0) {
		sansthaIds = adminSansthas.map(s => s.sanstha)
	} else if (permissionSansthas.length > 0) {
		const validPermissionSansthas = permissionSansthas.filter(
			s => s.permissions && s.permissions.length > 0,
		)

		sansthaIds = validPermissionSansthas.map(s => s.sanstha)
	}

	const sansthaList = useSelector(state => state.sansthaReducer.sanstha)

	const sansthaOptions = sansthaList
		.filter(s => sansthaIds.includes(s._id))
		.map(s => ({
			label: s.name,
			value: s._id,
		}))

	const selectedSanstha = sansthaOptions.find(option => option.value === selectedSansthaId)

	useEffect(() => {
		if (sansthaList.length === 0) {
			dispatch(appGetAllSanstha({ page: 1, limit: 1000 }))
		}
	}, [dispatch, sansthaList.length])

	// useEffect(() => {
	// 	const id = localStorage.getItem('sansthaId')
	// 	if (id) setSelectedSansthaId(id)
	// }, [])

	useEffect(() => {
		if (sansthaOptions.length > 0) {
			const storedId = localStorage.getItem('sansthaId')

			if (storedId && sansthaOptions.find(s => s.value === storedId)) {
				setSelectedSansthaId(storedId)
			} else {
				const firstId = sansthaOptions[0].value
				setSelectedSansthaId(firstId)
				localStorage.setItem('sansthaId', firstId)
			}
		}
	}, [sansthaOptions])

	useEffect(() => {
		if (!selectedSansthaId) return

		const adminSansthas = user?.adminOfSanstha || []
		const permissionSansthas = user?.permissionOfSanstha || []

		if (adminSansthas.length > 0) {
			navigate('/dashboard')
			return
		}

		if (permissionSansthas.length > 0) {
			const matched = permissionSansthas.find(s => s.sanstha === selectedSansthaId)

			const permissionNames = matched?.permissions?.map(p => p.name) || []

			if (permissionNames.length > 0) {
				navigate(`/${permissionNames[0]}`)
			} else {
				navigate('/')
			}
		}
	}, [])

	// const handleSansthaSelect = selected => {
	// 	if (!selected || selected.value === selectedSansthaId) return

	// 	setSelectedSansthaId(selected.value)
	// 	localStorage.setItem('sansthaId', selected.value)

	// 	if (adminSansthas.length > 0) {
	// 		dispatch(appGetAllDashboard())
	// 		navigate('/dashboard')
	// 		return
	// 	}

	// 	if (permissionSansthas.length > 0) {
	// 		const matched = permissionSansthas.find(s => s.sanstha === selected.value)

	// 		const permissionNames = matched?.permissions?.map(p => p.name) || []

	// 		localStorage.setItem('permissions', permissionNames.join(','))

	// 		window.location.reload()
	// 	}
	// }

	const handleSansthaSelect = selected => {
		if (!selected || selected.value === selectedSansthaId) return

		setSelectedSansthaId(selected.value)
		localStorage.setItem('sansthaId', selected.value)

		if (adminSansthas.length > 0) {
			dispatch(appGetAllDashboard())
			navigate('/dashboard', { replace: true })
			return
		}

		if (permissionSansthas.length > 0) {
			const matched = permissionSansthas.find(s => s.sanstha === selected.value)

			const permissionNames = matched?.permissions?.map(p => p.name) || []

			localStorage.setItem('permissions', permissionNames.join(','))

			if (permissionNames.length > 0) {
				navigate(`/${permissionNames[0]}`, { replace: true })
			} else {
				navigate('/', { replace: true })
			}
		}
	}

	const handleLogout = () => {
		localStorage.clear()
		navigate('/', { replace: true })
	}

	return (
		<header className="topnavbar-wrapper">
			<nav className="navbar topnavbar">
				<a className="navbar-brand" href="#/" />

				<div className="brand-logo" style={{ marginLeft: '3.25rem' }}>
					<img
						className="img-fluid"
						src="/img/logo1.png"
						alt="App Logo"
						style={{ width: 60, height: 40 }}
					/>
				</div>

				<ul className="navbar-nav mr-auto flex-row" style={{ marginLeft: '3.25rem' }}>
					<li className="nav-item">
						<a
							className="nav-link d-none d-md-block p-0"
							href="#"
							data-toggle-state="aside-collapsed"
						>
							<em className="fas fa-bars" />
						</a>
					</li>

					<li>
						<div
							style={{
								position: 'absolute',
								left: '50%',
								top: '50%',
								transform: 'translate(-50%, -50%)',
								minWidth: 260,
							}}
						>
							<Select
								options={sansthaOptions}
								value={selectedSanstha || null}
								onChange={handleSansthaSelect}
								placeholder="Select Sanstha"
								classNamePrefix="react-select"
							/>
						</div>
					</li>
				</ul>

				{sansthaAdmin && (
					<ul className="navbar-nav flex-row align-items-center mr-3 text-white">
						<li className="nav-item d-flex align-items-center">
							<PostPreview value={sansthaAdmin?.profilePic || '/img/user.jpg'} />

							<div
								style={{
									lineHeight: 1.2,
									marginLeft: '8px',
								}}
							>
								<strong style={{ fontSize: '14px' }}>{adminName}</strong>
								<div className="text-white" style={{ fontSize: '14px' }}>
									{sansthaAdmin?.email}
								</div>
								<div className="text-white" style={{ fontSize: '14px' }}>
									{sansthaAdmin?.mobile}
								</div>
							</div>
						</li>
					</ul>
				)}

				<ul className="navbar-nav flex-row">
					<li className="nav-item">
						<span className="nav-link" onClick={handleLogout} style={{ cursor: 'pointer' }}>
							Log Out
						</span>
					</li>
				</ul>
			</nav>
		</header>
	)
}

export default Header
